import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./stylesheet/main.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// Пользователь у которого решены 1й и 5й день
// 67246e94eefa24a60bb7fab603e53a996313df4f73a9fb17ca0ee59e764a67c3

// Пользователь у которого решены все дний все задания
// 82655f455afdc3edd695604a4a99a389b60a502a46c47ef9ba09d23fc1344a86
